<template>
    <Modal :id="'cmp-licence-licence-accounts-licence-form'" @cancelled="onCancel">
      <template slot="header"> </template>
      <template slot="body">
        <div class="form-group">
            <Dropdown
                :id="'invoice_project_id'"
                class="m2"
                :options="invoiceProjectTV"
                required
                :selected="invoiceProjectTV.find((e) => e.value == statement.invoice_project_id)"
                :placeholder="$t('invoice_project')"
                :showValidationIcons="true"
                :immediateValidation="true"
                box
                deselect
                @selectedChange="(e) => onDropdownChange('invoice_project_id', e)"
                @validated="(e) => onDropdownValidation('invoice_project_id', e)"
            />
            <TextField
                class="m1"
                :id="'date'"
                required
                type="date"
                v-bind="textFieldConfig"
                :value="statement.date"
                :placeholder="$t('date')"
                @valuechanged="onTextFieldValueChange"
                @validated="onValidation"
            />
          
            <TextField
                class="m1"
                :id="'text'"
                required
                v-bind="textFieldConfig"
                :value="statement.text"
                :placeholder="$t('royalty_account')"
                @valuechanged="onTextFieldValueChange"
                @validated="onValidation"
            />
            <TextField
                class="m1"
                :id="'year'"
                required
                v-bind="textFieldConfig"
                :value="statement.year"
                :placeholder="$t('year')"
                @valuechanged="onTextFieldValueChange"
                @validated="onValidation"
            />

            <Dropdown
                :id="'period'"
                class="m2"
                :options="periodTV"
                required
                :selected="periodTV.find((e) => e.value == statement.period)"
                :placeholder="$t('period')"
                :showValidationIcons="true"
                :immediateValidation="true"
                box
                deselect
                @selectedChange="(e) => onDropdownChange('period', e)"
                @validated="(e) => onDropdownValidation('period', e)"
            />
            <Dropdown
                :id="'currency_id'"
                class="m2"
                :options="currencyTV"
                required
                :selected="currencyTV.find((e) => e.value == statement.currency_id)"
                :placeholder="$t('currency')"
                :showValidationIcons="true"
                :immediateValidation="true"
                box
                deselect
                @selectedChange="(e) => onDropdownChange('currency_id', e)"
                @validated="(e) => onDropdownValidation('currency_id', e)"
            />

          
        </div>
      </template>
      <template slot="options">
        <button class="dt-button s6" @click.stop="onCancel">Cancel</button>
        <button
          class="dt-button v1 with-ico"
          :class="{ disabled: !isFormValid }"
          :disabled="!isFormValid"
          @click.stop="onOkClick"
        >
          {{ $t("continue") }}
        </button>
      </template>
    </Modal>
  </template>
  
  <script>
  import Modal from "@dtplugins/modal/modal";
  import { licenceAccountsService } from "../../services/licence-accounts.service";
  
  import { createTV, tv } from "../../../../models/text-value.model";
  import { openModalRoute2 } from "../../../../dt-plugins/modal/modal.mixin";
  import { format } from "date-fns";
  export default {
    components: {
      Modal,
    },
    props: {},
    data: function () {
      return {
        textFieldConfig: {
          height: 42,
          showEditIconOnHover: false,
          box: true,
          showValidationIcons: true,
          immediateValidation: true,
        },
  
        statement: {
          date: format(new Date(), "YYYY-MM-DD"),
          text: "Royalty Statement",
          period: null,
          currency_id: null,
          invoice_project_id: null,
          year: null,
        },
        currencyList: [],
        invoiceProjectList:[],
        validationResult: {},
      };
    },
    mounted: async function () {
      const res = await licenceAccountsService.addLicenceIncomeModal1Data(
        this.licence_account_id
      );
      this.currencyList = res.data.currencies;
      this.invoiceProjectList = res.data.invoice_projects
      
      console.log("WERE", res);
    },
    computed: {
      isFormValid: function () {
        return Object.values(this.validationResult).every((e) => e?.valid);
      },
      licence_account_id: function() {
      return this.$route.query.licence_account_id;
      },
      invoiceProjectTV:function(){
        return createTV(this.invoiceProjectList, "invoice_project_name", "invoice_project_id");
      },
      currencyTV: function () {
        return createTV(this.currencyList, "currency_iso", "currency_id");
      },
      periodTV: function (params) {
        return [
            { text: "S1", value: "S1" },
            { text: "S2", value: "S2" },
            { text: "Q1", value: "Q1" },
            { text: "Q2", value: "Q2" },
            { text: "Q3", value: "Q3" },
            { text: "Q4", value: "Q4" },
            { text: "M1", value: "M1" },
            { text: "M2", value: "M2" },
            { text: "M3", value: "M3" },
            { text: "M4", value: "M4" },
            { text: "M5", value: "M5" },
            { text: "M6", value: "M6" },
            { text: "M7", value: "M7" },
            { text: "M8", value: "M8" },
            { text: "M9", value: "M9" },
            { text: "M10", value: "M10" },
            { text: "M11", value: "M11" },
            { text: "M12", value: "M12" },
        ];
     },
    },
    methods: {
      onValidation: function (name, value) {
        this.$set(this.validationResult, name, value);
      },
      onDropdownValidation(name, value) {
        this.$set(this.validationResult, name, value);
      },
      onDropdownChange: function (name, value) {
        // <-- Normal Form Handling Methods
        console.log(name, value, this[name]);
        this.statement[name] = value.value;
        if (value.value != "0") {
          
        }
      },
      onTextFieldValueChange: function (name, value) {
        console.log("NAME", name, value);
        this.statement[name] = value;
      },
      onCancel: function () {
        this.$emit("cancelled", true);
      },
      onOkClick: function (e) {
        console.log(this.statement,"::::::::::::::");
        this.$emit("openNewForm2", { licence_account_id:this.licence_account_id,...this.statement});
        // openModalRoute2(this,"newStatementForm2",{
        //   ...this.statement
        // });
      },
      //MARK: Methods
    },
  };
  </script>
  <style lang="scss">
  .cmp-licence-licence-accounts-licence-form {
    .flex-container {
      display: flex;
      padding: 10px;
      .flex-item {
        flex: 0.25;
        padding: 10px;
      }
    }
    .ut-flex {
      padding-left: 10px;
      padding-top: 5px;
      flex-wrap: nowrap;
      p {
        margin-bottom: 0px;
      }
    }
  }
  </style>
  